import { useEffect, useState } from "react";
import { fetchGet } from "../../services/useFetch";
import { ConfigItem } from "../../types/requestTypes";

export interface IProp {
  setErrorMessage?: (msg: string) => void;
}
export const useConfigList = ({ setErrorMessage }: IProp) => {
  const [configList, setConfigList] = useState<ConfigItem[]>([]);

  useEffect(() => {
    loadConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadConfig = () => {
    fetchGet(`config`, false)
      .then(payload => payload.json())
      .then(data => {
        setConfigList(data.items);
      })
      .catch(() => {
        if (setErrorMessage) {
          setErrorMessage(`Nie udało się wczytać konfiguracji`);
        }
      });
  };
  return { configList, loadConfig };
};
